

import { Action } from '@ngrx/store';
import { BeforeStart } from '../../model/ngrx/before-start.model';
import * as BeforeStartActions from './../actions/before-start.actions';

export type Actions = BeforeStartActions.Actions;

export function BeforeStartReducer(state: BeforeStart[] = [], action: BeforeStartActions.Actions) {
    switch (action.type) {
        case BeforeStartActions.ADD_BEFORE_START:
            return [...state, action.payload];
        case BeforeStartActions.REMOVE_BEFORE_START:
            state = [];
            return state;

        default:
            return state;
    }
}
